const _ = require('lodash');
const fileSaver = require('file-saver');
const computed = require('../computed/account/statistic');

// при изменении этих парамтеров нужно править соответствующие размеры во всех css,
// которые лежат в  components/statistic
let cellWidth = 145;
let cellHeight = 27;
let headerHeight = 100;
let headerWidth = 225;
let xAmount = 70;
let yAmount = 70;
// чтобы наш блок элементов можно было удобно смотреть не только вниз и вправо,
// мы подгружаем элементы, которые левее и выше
let overlapAmount = 20;

// таймер периодичного запроса статистики, когда ожидаем её появления
let getStatisticTimerId;
let statisticRequestId = 0;
let lastProcessedStatisticRequestId = 0;

module.exports = {
    setRows ({ yStartIndex = 0, xStartIndex = 0, statisticChunk }, state) {
        state.set(['account', 'statistic', 'yStartIndex'], Math.max(yStartIndex - overlapAmount, 0));
        state.set(['account', 'statistic', 'data'], statisticChunk.rows);
        state.set(['account', 'statistic', 'header', 'top', 'data'], statisticChunk.xHeader);
        state.set(['account', 'statistic', 'header', 'left', 'data'], statisticChunk.yHeader);
        state.set(['account', 'statistic', 'topOffset'],
            Math.max(yStartIndex - overlapAmount, 0) * cellHeight + headerHeight - 1);
        state.set(['account', 'statistic', 'leftOffset'],
            Math.max(xStartIndex - overlapAmount, 0) * cellWidth + headerWidth - 1);
        state.set(['account', 'statistic', 'height'], statisticChunk.yLastIndex * cellHeight + headerHeight);
        state.set(['account', 'statistic', 'width'], statisticChunk.xLastIndex * cellWidth + headerWidth);
    },

    addStartIndexesToArgs (args, state, output, { context }) {
        let scrollLeft = 0;
        let scrollTop = 0;

        if (!context.isServer) {
            let target = document.getElementById('scrollable');
            if (target) {
                scrollLeft = target.scrollLeft;
                scrollTop = target.scrollTop;
            }
        }

        args.xStartIndex = Math.ceil((scrollLeft || 0) / cellWidth);
        args.yStartIndex = Math.ceil((scrollTop || 0) / cellHeight);
    },

    getStatisticChunk ({ xStartIndex, yStartIndex }, state, output, { locator, context }) {
        if (getStatisticTimerId) {
            clearTimeout(getStatisticTimerId);
        }

        const API = locator.resolve('api');
        const orderId = state.get(['account', 'statistic', 'orderId']);
        const xExtended = state.get(['account', 'statistic', 'xExtended']) || [];
        const yExtended = state.get(['account', 'statistic', 'yExtended']) || [];
        const isTransposed = state.get(['account', 'statistic', 'isTransposed']) || false;
        const isByBranch = state.get(['account', 'statistic', 'isByBranch']) || false;

        getStatisticTimerId = setTimeout(function getStatisticRetry () {
            const request = API.getStatisticChunk(context, locator,
                { orderId, xStartIndex: Math.max(xStartIndex - overlapAmount, 0),
                    yStartIndex: Math.max(yStartIndex - overlapAmount, 0),
                    xAmount, yAmount, xExtended, yExtended, isTransposed, isByBranch });

            const requestId = statisticRequestId++;

            request.then((data) => {
                // если запросили статистику для одного заказа, а пользователь уже работает с другим, то заканчиваем
                if (state.get(['account', 'statistic', 'orderId']) !== orderId) {
                    output.orderChanged();
                    return;
                }

                const statusCode = _.get(data, 'status.code');

                if (statusCode === 404) {
                    getStatisticTimerId = setTimeout(getStatisticRetry, 10000);
                    return;
                }

                if (statusCode !== 200) {
                    output.error({ error: statusCode });
                    return;
                }

                // не даём старым запросам переписывать более новые данные, сохраняем порядок запросов
                if (requestId < lastProcessedStatisticRequestId) {
                    output.orderChanged();
                    return;
                }

                lastProcessedStatisticRequestId = requestId;
                output.success({ statisticChunk: data.content });
            }).catch((error) => output.error(error));
        }, 0);
    },

    transpose (args, state) {
        let xExtended = state.get(['account', 'statistic', 'xExtended']);
        state.set(['account', 'statistic', 'xExtended'], state.get(['account', 'statistic', 'yExtended']));
        state.set(['account', 'statistic', 'yExtended'], xExtended);
    },

    downloadExcel (args, state, output, { locator, context }) {
        const orderId = state.get(['account', 'statistic', 'orderId']);
        const isTransposed = state.get(['account', 'statistic', 'isTransposed']) || false;
        const isByBranch = state.get(['account', 'statistic', 'isByBranch']) || false;
        const API = locator.resolve('api');

        const request = API.downloadStatisticFile(context, locator, { orderId, isTransposed, isByBranch });

        request.then((response) => {
            if (response.code === 200) {
                const blob = new Blob([response.content], { type: response.contentType });
                const fileName = response.contentDisposition.match(/attachment; filename=(.+)/)[1];

                fileSaver.saveAs(blob, fileName);
                output.success();
            } else {
                output.error({ error: response.code });
            }
        }).catch((error) => output.error({ error }));
    },

    setComputedFields (args, state) {
        computed.queryObject(state);
    }
};



// WEBPACK FOOTER //
// ./actions/account/statistic.js